import React, { useEffect, useState } from "react";
import {
  FaArrowLeftLong,
  FaArrowRightLong,
  FaCircleArrowRight,
  FaCirclePlay,
} from "react-icons/fa6";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/scrollbar";
import { Helmet } from "react-helmet";

const Hero = () => {
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    const callSliders = async () => {
      try {
        const res = await fetch(
          process.env.REACT_APP_BASE_API_URL + "/sliders",
          {
            method: "GET",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        );

        const data = await res.json();
        setSliders(data);
        if (!res.status === 200) {
          const error = new Error(res.error);
          throw error;
        }
      } catch (err) {
        console.log(err);
      }
    };
    callSliders();
  }, []);

  return (
    <div className="z-0">
      <Helmet>
        <title>
          Mission Organ Protection | An Initiative by Micro Labs Limited
        </title>
        <meta
          name="description"
          content="Mission Organ Protection is an initiative by Micro Labs Limited focusing on diabetes awareness and related healthcare solutions."
        />
      </Helmet>

      <div
        className="overflow-hidden h-[64vh] sm:h-[70vh] md:h-[70vh] lg:h-[70vh] xl:h-[80vh] flex flex-col w-full sm:mb-4 bg-secondary mt-16 lg:mt-20"
        data-aos="fade-left"
        data-aos-easing="linear"
        data-aos-duration="300"
        crossOrigin="anonymous"
      >
        <div className=" relative flex justify-center items-center h-screen z-0">
          <Swiper
            modules={[Pagination, Navigation, Autoplay]}
            spaceBetween={50}
            slidesPerView={1}
            navigation={{
              nextEl: ".swiper-button-next-custom",
              prevEl: ".swiper-button-prev-custom",
            }}
            breakpoints={{
              640: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
              768: {
                slidesPerView: 1,
                spaceBetween: 40,
              },
              1024: {
                slidesPerView: 1,
                spaceBetween: 50,
              },
            }}
            loop={true}
            pagination={{ clickable: true }}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            style={{ width: "100%", height: "100%" }}
          >
            {sliders.length > 0 &&
              sliders.map((slider, index) => (
                <SwiperSlide key={index} style={{ height: "100%" }}>
                 
                  {/* Parent Container */}
                  <div className=" absolute w-full h-full flex items-center justify-center ">
                    {/* Text Section */}
                    <div className=" w-[46%] sm:w-[40%] md:w-[55%] lg:w-[55%] xl:w-[44%] pt-3 pb-3 bg-gray-800 opacity-60 rounded-xl absolute z-10 flex flex-col justify-center items-center text-center px-4 md:px-10 lg:px-20 bg-gradient-to-r from-teal-800 to-teal-600"
                     
                   
                    
                    >
                      <span className="xl:text-lg md:text-xl text-sm text-white font-inter font-light tracking-wider">
                        {slider.title}
                      </span>
                      <h1 className="text-white font-inter text-xl sm:text-3xl lg:text-4xl xl:text-5xl font-semibold md:mt-3">
                        {slider.caption}
                      </h1>
                      <p className="text-white w-[95%] xl:text-base md:text hidden md:block font-inter font-normal lg:mt-5 xl:mt-10">
                        {slider.description}
                      </p>
                      <div className="md:flex mt-2 md:mt-0 gap-4 lg:gap-4">
                        {slider.button_one_text && slider.button_one_link && (
                          <button
                            onClick={() => {
                              window.open(slider.button_one_link, "_self");
                            }}
                            className="bg-white flex items-center gap-2 text-secondary font-inter font-semibold text-xs lg:text-base lg:mt-10 md:mt-5 p-2 px-5 rounded-full hover:bg-primary hover:text-white"
                          >
                            {slider.button_one_text}
                            <FaCircleArrowRight />
                          </button>
                        )}
                        {slider.button_two_text && slider.button_two_link && (
                          <button
                            onClick={() => {
                              window.open(slider.button_two_link, "_self");
                            }}
                            className="bg-secondary flex items-center gap-2 text-white hover:bg-white hover:text-secondary font-inter font-semibold text-xs lg:text-base lg:mt-10 md:mt-5 p-3 px-5 rounded-full"
                          >
                            {slider.button_two_text}
                            <FaCirclePlay />
                          </button>
                        )}
                      </div>
                    </div>

                    <div>
                      
                    </div>

                    {/* Image Section */}
                    <img
                      src={slider.image}
                      alt="Hero Image"
                      className="w-full h-full object-cover "
                    />
                  </div>
                </SwiperSlide>
              ))}
          </Swiper>

          {/* Custom navigation buttons */}
          <button className="hidden md:block absolute z-30 transform -translate-y-1/2 rounded-full cursor-pointer border-2 border-navbar hover:bg-transparent hover:border-navbar/95 p-3 bg-navbar/95 hover:text-white left-10 swiper-button-prev-custom top-1/2">
            <FaArrowLeftLong size={24} className="text-3xl text-white" />
          </button>
          <button className="hidden md:block absolute z-30 transform -translate-y-1/2 rounded-full cursor-pointer border-2 border-navbar hover:bg-transparent hover:border-navbar/95 p-3 bg-navbar/95 hover:text-white right-10 swiper-button-next-custom top-1/2">
            <FaArrowRightLong size={24} className="text-3xl text-white" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Hero;
